<template>
  <b-modal v-model="display" 
           :hide-header-close="settings.hideHeaderClose"
           :no-close-on-backdrop="settings.noCloseOnBackdrop"
           :ok-disabled="!listingState.markers"
           :ok-only="settings.okOnly"
           @ok="saveLocation">
    <div slot="modal-title">
      {{ $t('message.booking.contact_step.pin_location') }}
    </div>
    <section class="text-black">
      <div v-if="settings.page === 'checkout'">
        <label>{{ $t('message.my_listings.location') }}</label>
        <div class="text-remark pb-3">{{ $t('message.my_listings.place_location_hint') }}</div>
      </div>
      <div class="d-flex pb-3" v-else>
        <div>
          <img src="/static/img/map.svg" width="32"/>
        </div>
        <div class="pl-3">
          {{ $t('message.my_listings.no_location_remark') }}
        </div>
      </div>
      <div class="mb-3">
        <gmap-autocomplete
            :placeholder="$t('message.my_listings.place_location_search')"
            class="form-control"
            @place_changed="getAddressData"/>
      </div>
      <div class="embed-responsive embed-responsive-16by9 rounded" v-show="listingState.center">
        <div class="embed-responsive-item">
          <gmap-map ref="gmap"
                    :center="listingState.center"
                    :zoom="14"
                    :options="{clickableIcons: false}"
                    @click="changeLocation"
                    style="width: 100%; height: 100%;">
            <gmap-marker
              v-for="(marker, index) in listingState.markers"
              :key="index"
              :position="marker.position"
              :clickable="true"
              v-if="listingState.markers"/>
          </gmap-map>
        </div>
      </div>
    </section>
    <div slot="modal-cancel" @click="display = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok" :disabled="true">{{ $t('message.button.confirm') }}</div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      settings: Object
    },
    data () {
      return {
        isInit: true,
        display: false,
        latitude: null,
        longitude: null
      }
    },
    computed: {
      ...mapGetters({
        preCheckoutData: 'booking/getPreCheckoutData',
        listingState: 'listing/getState'
      })
    },
    methods: {
      show (latitude, longitude, isInit) {
        this.display = true
        this.isInit = isInit
        if (this.isInit) {
          this.$store.commit('listing/SET_MAP_MARKERS', null)
        }
        this.setMap(latitude, longitude)
      },
      getAddressData (addressData) {
        const lat = addressData.geometry.location.lat()
        const lng = addressData.geometry.location.lng()
        this.setMap(lat, lng, true)
      },
      changeLocation (event) {
        this.isInit = false
        const lat = event.latLng.lat()
        const lng = event.latLng.lng()
        this.setMap(lat, lng)
      },
      setMap (lat, lng) {
        lat = parseFloat(lat)
        lng = parseFloat(lng)
        this.latitude = lat
        this.longitude = lng

        // Set map & markers
        const center = { lat: lat, lng: lng }
        this.$store.commit('listing/SET_MAP_CENTER', center)
        if (!this.isInit) {
          const markers = []
          markers[0] = { position: { lat: lat, lng: lng } }
          this.$store.commit('listing/SET_MAP_MARKERS', markers)
        }
      },
      saveLocation () {
        // Update pre-checkout data: latitude and longitude
        if (this.preCheckoutData && this.preCheckoutData.user_place) {
          const userPlace = {...this.preCheckoutData.user_place}
          userPlace.latitude = this.latitude
          userPlace.longitude = this.longitude
          this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', { key: 'user_place', value: userPlace })
        }
        // Emit event to parent
        this.$emit('savedLocation', { latitude: this.latitude, longitude: this.longitude })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/PinLocationModal.vue